import { ArrowLeft, CaptionTypography } from '@components/atoms';
import { Button, ButtonSize, ButtonVariant } from '@components/molecules';

type BackButtonProps = React.PropsWithChildren<{
	onAction: () => void;
}>;

const BackButton: React.FC<BackButtonProps> = ({ children, onAction }) => {
	return (
		<Button type="button" variant={ButtonVariant.HYPERLINK} size={ButtonSize.XS} onClick={onAction} className="h-5" data-testid="back-button">
			<div className="flex flex-row content-center items-center gap-1.5 transition-all hover:text-primary">
				<ArrowLeft className="h-4 w-4" />
				<CaptionTypography className="text-secondary">{children}</CaptionTypography>
			</div>
		</Button>
	);
};

export { BackButton };
